<template>
  <div class="container" id="app">
    <div class="top">
      <img src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift-bg1.png" alt="" />
    </div>
    <div class="form-group">
      <div class="form-center">
        <div class="form-item">
          <div class="label-name"><i class="form-icon">*</i>姓名</div>
          <div class="input-box"><input v-model="form.userName" type="textarea" /></div>
        </div>
        <div class="form-item">
          <div class="label-name"><i class="form-icon">*</i>手机号</div>
          <div class="input-box"><input v-model="form.userPhone" type="textarea" /></div>
        </div>
        <div class="form-item">
          <div class="label-name"><i class="form-icon">*</i>验证码</div>
          <div class="input-box veriCode">
            <input v-model="form.phoneVerifyCode" type="tel" />
            <span id="getCode" class="getCode" v-if="isverify">剩余{{ verifyLeftTime }}s</span>
            <span id="getCode" class="getCode" v-else @click="getVerifCode">获取验证码</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label-name"><i class="form-icon">*</i>区域</div>
          <div class="input-box area-input">
            <van-cell
              is-link
              :value="form.lenderLocation[0] ? form.lenderLocation[0].name + form.lenderLocation[1].name + form.lenderLocation[2].name : ''"
              :value-class="form.lenderLocation[0] ? 'selected' : ''"
              @click="openVanPopup"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="label-name">设备型号</div>
          <div class="input-box"><input v-model="form.modelName" type="textarea" /></div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <img id="submit" @click="submit" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift-submit.png" alt="" />
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-area :area-list="areaList" @confirm="onConfirm" @cancel="show = false" />
    </van-popup>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data"
export default {
  name: "business",
  components: {},
  data() {
    return {
      show: false,
      areaList: areaList,
      isverify: false,
      verifyLeftTime: 60,
      t: null,
      form: {
        userName: "",
        userPhone: "",
        phoneVerifyCode: "",
        modelName: "",
        lenderLocation: []
      },
      extSrc: "" //来源ID
    }
  },
  created() {
    this.extSrc = this.$route.query.extSrc || ""
    document.title = "三一云联"
    this.gatLog() //用户活动统计数据
  },
  methods: {
    getLenderName(value) {
      this.form.userName = value.replace(/[0-9]/g, "")
    },
    openVanPopup() {
      this.show = true
    },
    onConfirm(e) {
      this.form.lenderLocation = e
      this.show = false
    },
    getVerifCode() {
      this.$api.getVerifCode({ phoneNumber: this.form.userPhone }).then((res) => {
        if (res.data.code == 0) {
          this.isverify = true
          const second = Math.floor(new Date().getTime() / 1000)
          this.t = setInterval(() => {
            const newSecond = Math.floor(new Date().getTime() / 1000)
            const time = 60 - Math.round(newSecond - second)
            if (time < 1) {
              window.clearInterval(this.t)
              this.isverify = false
              this.verifyLeftTime = 60
            } else {
              this.verifyLeftTime = time
            }
          }, 1000)
        }
      })
    },
    submit() {
      if (this.form.userName == "") {
        this.$toast({ message: "请填写姓名", position: "bottom" })
        return
      }
      if (this.form.userPhone == "") {
        this.$toast({ message: "请填写手机号码", position: "bottom" })
        return
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.userPhone)) {
        this.$toast({ message: "请填写正确的手机号码", position: "bottom" })
        return
      }
      if (this.form.phoneVerifyCode == "") {
        this.$toast({ message: "请填写验证码", position: "bottom" })
        return
      }
      if (this.form.lenderLocation.length == 0) {
        this.$toast({ message: "请选择区域", position: "bottom" })
        return
      }
      const data = {
        userName: this.form.userName,
        userPhone: this.form.userPhone,
        phoneVerifyCode: this.form.phoneVerifyCode,
        provinceName: this.form.lenderLocation[0].name,
        provinceCode: this.form.lenderLocation[0].code,
        cityName: this.form.lenderLocation[1].name,
        cityCode: this.form.lenderLocation[1].code,
        districtName: this.form.lenderLocation[2].name,
        districtCode: this.form.lenderLocation[2].code,
        modelName: this.form.modelName
      }
      this.$api.addLottery(data).then((res) => {
        if (res.data.code == 0) {
          this.$router.push({
            path: "/lottery",
            query: {
              userPhone: this.form.userPhone
            }
          })
        } else {
          this.$toast({ message: res.data.msg, position: "bottom" })
        }
      })
    },
    gatLog() {
      this.$api.gatewayLog({ extSrc: this.extSrc }).then((res) => {})
    }
  }
}
</script>
<style lang="scss">
.container {
  .van-cell {
    background: rgba(255, 245, 227, 1);
    border: 1px solid #ddd;
    margin-top: 0;
  }
  .area-input .van-cell {
    padding-right: 0.1rem;
    height: 1.2rem;
  }
}
</style>
<style lang="scss" scoped>
.container {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
.top {
  width: 100%;
}
.top img {
  width: 100%;
  line-height: 0;
}
.form-group {
  width: 100%;
  padding: 0.5rem 0;
  background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift-bg2.png");
  margin-top: -4px;
}
.form-center {
  background-color: rgba(255, 252, 239, 1);
  width: 90%;
  margin: 0 auto;
  border-radius: 10px;
  padding: 0.5rem 0;
}
.form-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.3rem;
}
.form-item .label-name {
  width: 2rem;
  height: 1rem;
  font-size: 0.4rem;
  line-height: 1rem;
  text-align: left;
}
.label-name .form-icon {
  color: red;
  margin-right: 0.2rem;
}
.form-item .input-box {
  width: 6rem;
  margin-right: 0.4rem;
  font-size: 0.4rem;
}
.form-item .area-input {
  width: 6rem;
}
.form-item input {
  border: 1px solid #ddd;
  width: 6rem;
  box-sizing: border-box;
  height: 1.2rem;
  border-radius: 10px;
  background-color: rgba(255, 245, 227, 1);
  padding: 0.26667rem 0.42667rem;
}
.form-item .veriCode {
  text-align: left;
}
.form-item .veriCode input {
  width: 3rem;
  margin-right: 0.2rem;
}
.form-item .veriCode .getCode {
  color: rgba(251, 70, 63, 1);
}

.bottom {
  width: 100%;
  margin-top: -1px;
}
.bottom img {
  width: 100%;
}
</style>
